import { CarReservation, CarsCancellationPolicyEnum } from "redmond";
import { RestrictionCancelEnum } from "@b2bportal/ground-api";

type BookResult = CarReservation["bookResult"];
type Vehicle = BookResult["vehicle"];

// Bag counts are a partition of the vehicle's total capacity across bag sizes
// (suppliers report e.g. {Small: 3, Big: 2} for a 5-bag car), so sum them.
// Returns undefined when the supplier reported no capacity at all, which is
// distinct from a supplier reporting zero.
export const getTotalBaggageQty = (vehicle: Vehicle) => {
  const quantities = Object.values(vehicle.bagsInfo);
  return quantities.length > 0
    ? quantities.reduce((total, qty) => total + qty, 0)
    : undefined;
};

const RESTRICTION_CANCEL_POLICY_MAP: Record<
  string,
  CarsCancellationPolicyEnum
> = {
  [RestrictionCancelEnum.Conditional]: CarsCancellationPolicyEnum.Conditional,
  [RestrictionCancelEnum.ConditionalAfterBooking]:
    CarsCancellationPolicyEnum.ConditionalAfterBooking,
  [RestrictionCancelEnum.Free]: CarsCancellationPolicyEnum.FreeCancellation,
  [RestrictionCancelEnum.NonRefundable]:
    CarsCancellationPolicyEnum.NonRefundable,
  [RestrictionCancelEnum.Paid]: CarsCancellationPolicyEnum.PartiallyRefundable,
  [RestrictionCancelEnum.SteppedCancellationRule]:
    CarsCancellationPolicyEnum.PartiallyRefundable,
};

// `extensions.cancellation.free` only distinguishes fully-free from everything
// else, so without this the availability tag falls back to "Non refundable" for
// bookings that are cancellable up to a cutoff.
export const getCancellationPolicy = (bookResult: BookResult) => {
  const restriction = bookResult.cancellationRules?.RestrictionCancel;

  return restriction ? RESTRICTION_CANCEL_POLICY_MAP[restriction] : undefined;
};
